module.exports = __webpack_public_path__ + "media/facial-recognition/side-view-1acc10fd.svg";